import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IConfigurations, defaultValue } from 'app/shared/model/configurations.model';
const initialState: EntityState<IConfigurations> = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IConfigurations>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};

const apiUrl = 'api/app-config';

// Actions

export const getConfigurations = createAsyncThunk('appConfig/fetch_appConfig_list', async () => {
  const requestUrl = `${apiUrl}`;
  return axios.get<IConfigurations[]>(requestUrl);
});

export const getConfig = createAsyncThunk(
  'appConfig/fetch_appConfig',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<IConfigurations>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const updateConfig = createAsyncThunk(
  'appConfig/update_appConfig',
  async (entity: IConfigurations, thunkAPI) => {
    const result = await axios.put<IConfigurations>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getConfigurations());
    return result;
  },
  { serializeError: serializeAxiosError }
);

export type AppConfigState = Readonly<typeof initialState>;

// slice

export const AppConfigSlice = createSlice({
  name: 'appConfig',
  initialState: initialState as AppConfigState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addMatcher(isFulfilled(updateConfig), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })

      .addMatcher(isFulfilled(getConfigurations), (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
        state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
      })
      .addMatcher(isPending(updateConfig), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = AppConfigSlice.actions;

// Reducer
export default AppConfigSlice.reducer;
